import axios from "axios";
import { DataGrid, Popover } from "devextreme-react";
import {
  Button,
  Column,
  ColumnFixing,
  Editing,
  FilterRow,
  Form,
  HeaderFilter,
  Item,
  LoadPanel,
  Lookup,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
  ToolbarItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { observerInstance } from "../common/ResizeObserver";
import { projectStatus } from "../SalesManagement/Payment/data";
import ColorComponent from "./ContractRegistration/ColorComponent";
import QuotationListDataGrid from "./ContractRegistration/QuotationListDataGrid";
import ProjectAssignment from "./ProjectAssign/ProjectAssignment";
import ContractForm from "./ContractForm";
import { useDispatch, useSelector } from "react-redux";
import { updateAll } from "./Redux/contract";

const ContractListWrapper = styled.div`
  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
  .dx-button {
    margin: 0 5px;
    float: left;
  }
  #infoButton {
    i {
      font-size: inherit;
    }
  }
  .edit-status-col {
    padding: 0 !important;
  }
  #contractListDataGrid {
    max-width: 99vw;
  }
`;

const InfoWrapper = styled.div`
  padding: 0 16px;
  > h3 {
    margin: 0;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
  > li {
    margin: 0;
    list-style: none;
    margin-top: 0.5em;
    padding-left: 1.5em;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    > div {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 24px;
      box-shadow: 0px 0px 0px 1px gray;
    }
  }
  > div:last-child {
    display: grid;
    grid-template-columns: 60px auto;
    grid-gap: 0.5em;
    margin-top: 0.5em;
    > div:nth-child(odd) {
      font-weight: bold;
      text-align: center;
    }
  }
`;

export default function ContractListDataGrid(props) {
  const { uploadedContrNo, path, title } = props;

  const contractListGridRef = useRef(null);
  const quotationListGridRef = useRef(null);

  const [contractListDataSource, setContractListDataSource] = useState(null);
  const [contrNo, setContrNo] = useState(null);
  const [priorityDataSource, setPriorityDataSource] = useState(null);

  const [contractPopupVisible, setContractPopupVisible] = useState(false);

  const contractFormRef = useRef(null);

  const contract = useSelector((state) => state.contract);
  const dispatch = useDispatch();

  useEffect(() => {
    getContractList();

    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/common/codeList?name=Priority&cat=10`
      )
      .then((res) => {
        //  prioCodeListId = res.data.codeListId;

        setPriorityDataSource(res.data.code);
      });
  }, []);

  useEffect(() => {
    if (uploadedContrNo) {
      //   getContractList();

      const dataSource = contractListGridRef.current.instance.getDataSource();

      if (dataSource) {
        const contractListGridRefInstance =
          contractListGridRef.current.instance;

        contractListGridRefInstance.getDataSource().reload();
        contractListGridRefInstance.selectRows(Array.of(uploadedContrNo));

        if (quotationListGridRef.current.instance.getDataSource()) {
          quotationListGridRef.current.instance.getDataSource().reload();
        }
      }
    }
  }, [uploadedContrNo]);

  const getContractList = () => {
    setContractListDataSource(
      new CustomStore({
        key: "contrNo",
        load: async () => {
          try {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg`
            );

            // contractListGridRef.current.instance.selectRows(uploadedContrNo);

            return result.data;
          } catch (error) {
            console.log(error);
          }
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg/${key.contrNo}`,
            values
          );
        },
      })
    );
  };

  const onSelectionChanged = (e) => {
    setContrNo(e.selectedRowKeys[0]);

    // contractListGridRef.current.instance.repaint();
  };

  const cellRender = (data) => {
    return (
      <div
        // className="dx-colorbox-color-result-preview"
        style={{
          backgroundColor: data.data.color,
          left: "13px",
          width: "17px",
          height: "17px",
          border: "1px solid",
          borderColor: "#e0e0e0",
          margin: "0 auto",
        }}
      >
        {/* {data.data.color} */}
      </div>
    );
  };

  const onClick = (e) => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg/file/template`,
        {
          responseType: "blob",
        }
      )
      .then((result) => {
        if (result.headers["content-disposition"]) {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement("a");
          link.href = url;

          let fileName = null;

          if (
            result.headers["content-disposition"].includes(`filename*=UTF-8''`)
          ) {
            fileName = decodeURI(
              result.headers["content-disposition"].split(
                `filename*=UTF-8''`
              )[1]
            );
          } else {
            fileName = result.headers["content-disposition"]
              .split("=")[1]
              .replace(/"/g, "");
          }

          // const fileName = result.headers["content-disposition"]
          //   .split("=")[1]
          //   .replace(/"/g, "");

          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        } else {
          console.log("[warning]");
        }
      });
  };

  const cellRenderSprName = (data) => {
    return (
      <div>
        <span>{data.data.sprName}</span>
        <br />
        <span style={{ fontSize: "11px" }}>{data.data.sprEnName}</span>
      </div>
    );
  };

  const onChangesChange = (changes) => {
    if (changes.length > 0) {
      contractListDataSource.update(changes[0].key, changes[0].data);
      contractListGridRef.current.instance.refresh();
    }

    // applyChanges(contractListDataSource, changes);
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "data" && e.column.caption == "Priority") {
      const prioCodeId = e.data.prioCodeId;
      const prioColor = e.data.prioColor;

      if (prioCodeId && prioColor) {
        e.cellElement.style.backgroundColor = prioColor;
      }
    }
  };

  const contentRender = useCallback(
    (data) => {
      return (
        <ContractForm
          contractFormRef={contractFormRef}
          priorityDataSource={priorityDataSource}
          contract={contract}
        />
      );
    },
    [contract]
  );

  const onInitialized = ({ component, element }) => {
    observerInstance.subscribe(
      component,
      element.parentNode,
      component.repaint,
      100,
      0
    );
  };

  const onEditingStart = (e) => {
    dispatch(
      updateAll({
        ...e.data,
      })
    );

    setContractPopupVisible(true);
  };

  const onSaveClick = useCallback(() => {
    if (contractFormRef.current.instance.validate().isValid) {
      setContractPopupVisible(false);

      contractListGridRef.current.instance
        .getDataSource()
        .store()
        .update(
          {
            contrNo: contract.contrNo,
          },
          contract
        )
        .then(() => {
          contractListGridRef.current.instance.refresh();
        });
    }
  }, [contract]);

  return (
    <ContractListWrapper>
      <div style={{ display: "flex" }}>
        <DataGrid
          id="contractListDataGrid"
          ref={contractListGridRef}
          dataSource={contractListDataSource}
          keyExpr="contrNo"
          // rowAlternationEnabled={true}
          showBorders={true}
          showColumnLines={true}
          allowColumnResizing={true}
          columnAutoWidth={true}
          // width={"30%"}
          width={"50%"}
          wordWrapEnabled={true}
          allowColumnReordering={true}
          // height={"100%"}
          height={"auto"}
          style={{
            maxHeight: `calc(100vh - ${path == "ContrReg" ? 260 : 180}px)`,
            marginLeft: "10px",
            marginRight: "10px",
          }}
          // hoverStateEnabled={true}
          // dataRowRender={DataRow}
          onSelectionChanged={onSelectionChanged}
          onCellPrepared={onCellPrepared}
          // onInitialized={onInitialized}
          onEditingStart={onEditingStart}
        >
          <LoadPanel enabled={true} />
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel visible={true} />
          <Scrolling mode={"virtual"} showScrollbar={"always"} />
          <Selection mode={"single"} />

          {/* <ColumnFixing enabled={true} /> */}

          {/* <Editing
            mode={"cell"}
            allowUpdating={true}
            onChangesChange={onChangesChange}
          /> */}
          <Editing
            refreshMode={"reshape"}
            mode={"popup"}
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={false}
          >
            <Popup
              visible={contractPopupVisible}
              showTitle={true}
              title={"Edit the Contract"}
              height={"auto"}
              width={1200}
              maxHeight={"90vh"}
              maxWidth={"90vw"}
              showCloseButton={true}
              contentRender={contentRender}
            >
              <ToolbarItem
                widget={"dxButton"}
                toolbar={"top"}
                location={"after"}
                options={{
                  icon: "save",
                  type: "normal",
                  stylingMode: "contained",
                  onClick: onSaveClick,
                }}
              />
            </Popup>
          </Editing>

          {/* <StateStoring
            enabled={true}
            type="localStorage"
            storageKey={"ProjectSetup.ContractListDataGrid"}
          /> */}

          <Column type={"buttons"} allowHiding={false} width={50}>
            <Button name={"edit"} />
          </Column>
          <Column
            dataField={"sprCode"}
            caption={"Sponsor Code"}
            dataType={"string"}
            allowEditing={path == "ContrReg" ? true : false}
            alignment={"center"}
            width={110}
          />

          <Column
            dataField={"spr"}
            caption="Sponsor"
            width={150}
            dataType="string"
            allowEditing={false}
            cellRender={cellRenderSprName}
          />
          <Column
            dataField={"projStatusCodeId"}
            caption={"Status"}
            dataType={"string"}
            alignment={"center"}
            width={100}
          >
            <Lookup
              dataSource={projectStatus}
              valueExpr={"codeId"}
              displayExpr={"name"}
            />
          </Column>
          <Column
            dataField={"prioCodeId"}
            alignment={"center"}
            caption={"Priority"}
            // minWidth={110}
            width={100}
            allowEditing={true}
          >
            <Lookup
              dataSource={priorityDataSource}
              displayExpr={"name"}
              valueExpr={"codeId"}
            />
            <HeaderFilter
              dataSource={priorityDataSource?.map(({ codeId, name }) => ({
                text: name,
                value: codeId,
              }))}
              allowSearch={true}
            />
          </Column>
          <Column
            dataField={"color"}
            cellRender={cellRender}
            width={70}
            editCellComponent={ColorComponent}
            caption=""
            allowFiltering={false}
          />
          <Column
            dataField={"contrNo"}
            caption="Contract No."
            width={150}
            dataType="string"
            alignment={"center"}
            allowEditing={false}
          />
          <Column
            dataField={"name"}
            caption="Project Name"
            allowEditing={false}
            minWidth={390}
          />

          <Toolbar>
            <Item location="before">
              <span style={{ fontWeight: 500, color: "#009688" }}>{title}</span>
            </Item>
            {/* <Item location="before">
            <Button
              icon="download"
              style={{
                margin: 0,
              }}
              onClick={onClick}
            />
          </Item> */}
            <Item
              location="after"
              name="infoButton"
              options={{
                elementAttr: { id: "infoButton" },
                icon: "fa-solid fa-info",
                stylingMode: "outlined",
                type: "normal",
              }}
              widget="dxButton"
            />
            <Item name={"searchPanel"} location="after" />
          </Toolbar>
        </DataGrid>
        <Popover
          hideEvent={"mouseleave"}
          showEvent={"mouseenter"}
          target={"#infoButton"}
        >
          <InfoWrapper>
            <h3>Priority</h3>
            <div>
              {priorityDataSource?.map((el, idx) => {
                return (
                  <>
                    <div key={`name${idx}`}>{el.name}</div>
                    <div key={`descr${idx}`}>{el.descr}</div>
                  </>
                );
              })}
            </div>
          </InfoWrapper>
        </Popover>
        {path == "ContrReg" && (
          <QuotationListDataGrid
            contrNo={contrNo}
            quotationListGridRef={quotationListGridRef}
            contractListGridRef={contractListGridRef}
          />
        )}
        {path == "PrjAsgmt" && <ProjectAssignment contrNo={contrNo} />}
      </div>
    </ContractListWrapper>
  );
}
